module.exports = new __parcel__URL__("../SVG/chevron-right.9c13525e.svg").toString();